const { initAnalyticsNext } = require('./analyticsNext');

function init(config, initCallback) {
    initAnalyticsNext(config, initCallback);
}

module.exports = {
    init: init
};
